<template>
  <div class="form-group" align="left">
    <div class="form-row">
      <div class="form-input" :class="classes">
        <input
          type="tel"
          :value="value"
          @input="$emit('input', $event.target.value)"
          class="form-control"
          id="CVV"
          data-test="cvv-field-input"
          :placeholder="$t('paymentdetails.cards.placeholderCvv')"
          maxlength="4"
        />
        <label for="CVV" data-test="cvv-field-label">{{
          $t("paymentdetails.cards.labelCvv")
        }}</label>
        <div class="form-input-validation" data-test="form-input-validation">
          <div class="form-input-notes-left" :title="messages[0]">
            {{ messages[0] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "cvv",
  props: ["value", "messages", "flags"],
  computed: {
    classes() {
      if (this.flags.validated && !this.flags.valid) {
        return "error";
      }
      if (this.flags.validated && this.flags.valid) {
        return "success";
      }
      return "";
    },
  },
};
</script>
